/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EnrichmentJobBody,
  JobBody,
  WorkDTO,
} from '../models/index';
import {
    EnrichmentJobBodyFromJSON,
    EnrichmentJobBodyToJSON,
    JobBodyFromJSON,
    JobBodyToJSON,
    WorkDTOFromJSON,
    WorkDTOToJSON,
} from '../models/index';

export interface ImportWorkRequest {
    workDTO: Array<WorkDTO>;
    tenant?: ImportWorkTenantEnum;
}

export interface StartCrossrefJobRequest {
    workDTO: WorkDTO;
}

export interface StartGVIJobRequest {
    workDTO: WorkDTO;
}

export interface StartManualMmsEnrichmentJobRequest {
    workDTO: WorkDTO;
}

export interface StartMmsEnrichmentJobRequest {
    enrichmentJobBody: EnrichmentJobBody;
    pubtypes?: Array<string>;
    issuedBefore?: number;
    issuedAfter?: number;
}

export interface StartMmsEnrichmentJob1Request {
    requestBody: Array<number>;
    pubtypes?: Array<string>;
    issuedBefore?: number;
    issuedAfter?: number;
}

export interface StartMmsPersonLinkingJobRequest {
    requestBody: Array<number>;
}

export interface StartOpenAlexDeltaJobRequest {
    jobBody: JobBody;
}

export interface StartOpenAlexJobRequest {
    requestBody: Array<string>;
}

export interface StartScopusDeltaJobRequest {
    jobBody: JobBody;
    tenant?: StartScopusDeltaJobTenantEnum;
}

export interface StartScopusJobRequest {
    requestBody: Array<string>;
    tenant?: StartScopusJobTenantEnum;
}

export interface StartWosDeltaJobRequest {
    jobBody: JobBody;
    tenant?: StartWosDeltaJobTenantEnum;
}

export interface StartWosJobRequest {
    requestBody: Array<string>;
    tenant?: StartWosJobTenantEnum;
}

/**
 * 
 */
export class ImportServiceApi extends runtime.BaseAPI {

    /**
     * Creates request options for importWork without sending the request
     */
    async importWorkRequestOpts(requestParameters: ImportWorkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workDTO'] == null) {
            throw new runtime.RequiredError(
                'workDTO',
                'Required parameter "workDTO" was null or undefined when calling importWork().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenant'] != null) {
            queryParameters['tenant'] = requestParameters['tenant'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['workDTO']!.map(WorkDTOToJSON),
        };
    }

    /**
     */
    async importWorkRaw(requestParameters: ImportWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.importWorkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importWork(requestParameters: ImportWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importWorkRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for startCrossrefJob without sending the request
     */
    async startCrossrefJobRequestOpts(requestParameters: StartCrossrefJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workDTO'] == null) {
            throw new runtime.RequiredError(
                'workDTO',
                'Required parameter "workDTO" was null or undefined when calling startCrossrefJob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/crossref`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkDTOToJSON(requestParameters['workDTO']),
        };
    }

    /**
     */
    async startCrossrefJobRaw(requestParameters: StartCrossrefJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkDTO>> {
        const requestOptions = await this.startCrossrefJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkDTOFromJSON(jsonValue));
    }

    /**
     */
    async startCrossrefJob(requestParameters: StartCrossrefJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkDTO> {
        const response = await this.startCrossrefJobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startGVIJob without sending the request
     */
    async startGVIJobRequestOpts(requestParameters: StartGVIJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workDTO'] == null) {
            throw new runtime.RequiredError(
                'workDTO',
                'Required parameter "workDTO" was null or undefined when calling startGVIJob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/gvi`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkDTOToJSON(requestParameters['workDTO']),
        };
    }

    /**
     */
    async startGVIJobRaw(requestParameters: StartGVIJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkDTO>> {
        const requestOptions = await this.startGVIJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkDTOFromJSON(jsonValue));
    }

    /**
     */
    async startGVIJob(requestParameters: StartGVIJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkDTO> {
        const response = await this.startGVIJobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startManualMmsEnrichmentJob without sending the request
     */
    async startManualMmsEnrichmentJobRequestOpts(requestParameters: StartManualMmsEnrichmentJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workDTO'] == null) {
            throw new runtime.RequiredError(
                'workDTO',
                'Required parameter "workDTO" was null or undefined when calling startManualMmsEnrichmentJob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/mms/manual`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkDTOToJSON(requestParameters['workDTO']),
        };
    }

    /**
     */
    async startManualMmsEnrichmentJobRaw(requestParameters: StartManualMmsEnrichmentJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkDTO>> {
        const requestOptions = await this.startManualMmsEnrichmentJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkDTOFromJSON(jsonValue));
    }

    /**
     */
    async startManualMmsEnrichmentJob(requestParameters: StartManualMmsEnrichmentJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkDTO> {
        const response = await this.startManualMmsEnrichmentJobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startMmsEnrichmentJob without sending the request
     */
    async startMmsEnrichmentJobRequestOpts(requestParameters: StartMmsEnrichmentJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['enrichmentJobBody'] == null) {
            throw new runtime.RequiredError(
                'enrichmentJobBody',
                'Required parameter "enrichmentJobBody" was null or undefined when calling startMmsEnrichmentJob().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pubtypes'] != null) {
            queryParameters['pubtypes'] = requestParameters['pubtypes'];
        }

        if (requestParameters['issuedBefore'] != null) {
            queryParameters['issued_before'] = requestParameters['issuedBefore'];
        }

        if (requestParameters['issuedAfter'] != null) {
            queryParameters['issued_after'] = requestParameters['issuedAfter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/mms`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EnrichmentJobBodyToJSON(requestParameters['enrichmentJobBody']),
        };
    }

    /**
     */
    async startMmsEnrichmentJobRaw(requestParameters: StartMmsEnrichmentJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.startMmsEnrichmentJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async startMmsEnrichmentJob(requestParameters: StartMmsEnrichmentJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.startMmsEnrichmentJobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startMmsEnrichmentJob1 without sending the request
     */
    async startMmsEnrichmentJob1RequestOpts(requestParameters: StartMmsEnrichmentJob1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling startMmsEnrichmentJob1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pubtypes'] != null) {
            queryParameters['pubtypes'] = requestParameters['pubtypes'];
        }

        if (requestParameters['issuedBefore'] != null) {
            queryParameters['issued_before'] = requestParameters['issuedBefore'];
        }

        if (requestParameters['issuedAfter'] != null) {
            queryParameters['issued_after'] = requestParameters['issuedAfter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/mms/list`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async startMmsEnrichmentJob1Raw(requestParameters: StartMmsEnrichmentJob1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.startMmsEnrichmentJob1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async startMmsEnrichmentJob1(requestParameters: StartMmsEnrichmentJob1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startMmsEnrichmentJob1Raw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for startMmsPersonLinkingJob without sending the request
     */
    async startMmsPersonLinkingJobRequestOpts(requestParameters: StartMmsPersonLinkingJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling startMmsPersonLinkingJob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/mms/person/link`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async startMmsPersonLinkingJobRaw(requestParameters: StartMmsPersonLinkingJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.startMmsPersonLinkingJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async startMmsPersonLinkingJob(requestParameters: StartMmsPersonLinkingJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startMmsPersonLinkingJobRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for startOpenAlexDeltaJob without sending the request
     */
    async startOpenAlexDeltaJobRequestOpts(requestParameters: StartOpenAlexDeltaJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['jobBody'] == null) {
            throw new runtime.RequiredError(
                'jobBody',
                'Required parameter "jobBody" was null or undefined when calling startOpenAlexDeltaJob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/openAlex/delta`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JobBodyToJSON(requestParameters['jobBody']),
        };
    }

    /**
     */
    async startOpenAlexDeltaJobRaw(requestParameters: StartOpenAlexDeltaJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.startOpenAlexDeltaJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async startOpenAlexDeltaJob(requestParameters: StartOpenAlexDeltaJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startOpenAlexDeltaJobRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for startOpenAlexJob without sending the request
     */
    async startOpenAlexJobRequestOpts(requestParameters: StartOpenAlexJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling startOpenAlexJob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/openAlex`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async startOpenAlexJobRaw(requestParameters: StartOpenAlexJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.startOpenAlexJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async startOpenAlexJob(requestParameters: StartOpenAlexJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startOpenAlexJobRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for startScopusDeltaIdentification without sending the request
     */
    async startScopusDeltaIdentificationRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/scopus/delta/identification`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async startScopusDeltaIdentificationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.startScopusDeltaIdentificationRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async startScopusDeltaIdentification(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startScopusDeltaIdentificationRaw(initOverrides);
    }

    /**
     * Creates request options for startScopusDeltaJob without sending the request
     */
    async startScopusDeltaJobRequestOpts(requestParameters: StartScopusDeltaJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['jobBody'] == null) {
            throw new runtime.RequiredError(
                'jobBody',
                'Required parameter "jobBody" was null or undefined when calling startScopusDeltaJob().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenant'] != null) {
            queryParameters['tenant'] = requestParameters['tenant'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/scopus/delta`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JobBodyToJSON(requestParameters['jobBody']),
        };
    }

    /**
     */
    async startScopusDeltaJobRaw(requestParameters: StartScopusDeltaJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.startScopusDeltaJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async startScopusDeltaJob(requestParameters: StartScopusDeltaJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startScopusDeltaJobRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for startScopusJob without sending the request
     */
    async startScopusJobRequestOpts(requestParameters: StartScopusJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling startScopusJob().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenant'] != null) {
            queryParameters['tenant'] = requestParameters['tenant'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/scopus`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async startScopusJobRaw(requestParameters: StartScopusJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.startScopusJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async startScopusJob(requestParameters: StartScopusJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startScopusJobRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for startWosDeltaJob without sending the request
     */
    async startWosDeltaJobRequestOpts(requestParameters: StartWosDeltaJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['jobBody'] == null) {
            throw new runtime.RequiredError(
                'jobBody',
                'Required parameter "jobBody" was null or undefined when calling startWosDeltaJob().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenant'] != null) {
            queryParameters['tenant'] = requestParameters['tenant'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/wos/delta`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JobBodyToJSON(requestParameters['jobBody']),
        };
    }

    /**
     */
    async startWosDeltaJobRaw(requestParameters: StartWosDeltaJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.startWosDeltaJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async startWosDeltaJob(requestParameters: StartWosDeltaJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startWosDeltaJobRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for startWosJob without sending the request
     */
    async startWosJobRequestOpts(requestParameters: StartWosJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling startWosJob().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenant'] != null) {
            queryParameters['tenant'] = requestParameters['tenant'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/wos`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async startWosJobRaw(requestParameters: StartWosJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.startWosJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async startWosJob(requestParameters: StartWosJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startWosJobRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const ImportWorkTenantEnum = {
    Rub: 'RUB',
    Uwh: 'UWH',
    Hhu: 'HHU',
    Tudo: 'TUDO',
    Common: 'COMMON',
    Other: 'OTHER'
} as const;
export type ImportWorkTenantEnum = typeof ImportWorkTenantEnum[keyof typeof ImportWorkTenantEnum];
/**
 * @export
 */
export const StartScopusDeltaJobTenantEnum = {
    Rub: 'RUB',
    Uwh: 'UWH',
    Hhu: 'HHU',
    Tudo: 'TUDO',
    Common: 'COMMON',
    Other: 'OTHER'
} as const;
export type StartScopusDeltaJobTenantEnum = typeof StartScopusDeltaJobTenantEnum[keyof typeof StartScopusDeltaJobTenantEnum];
/**
 * @export
 */
export const StartScopusJobTenantEnum = {
    Rub: 'RUB',
    Uwh: 'UWH',
    Hhu: 'HHU',
    Tudo: 'TUDO',
    Common: 'COMMON',
    Other: 'OTHER'
} as const;
export type StartScopusJobTenantEnum = typeof StartScopusJobTenantEnum[keyof typeof StartScopusJobTenantEnum];
/**
 * @export
 */
export const StartWosDeltaJobTenantEnum = {
    Rub: 'RUB',
    Uwh: 'UWH',
    Hhu: 'HHU',
    Tudo: 'TUDO',
    Common: 'COMMON',
    Other: 'OTHER'
} as const;
export type StartWosDeltaJobTenantEnum = typeof StartWosDeltaJobTenantEnum[keyof typeof StartWosDeltaJobTenantEnum];
/**
 * @export
 */
export const StartWosJobTenantEnum = {
    Rub: 'RUB',
    Uwh: 'UWH',
    Hhu: 'HHU',
    Tudo: 'TUDO',
    Common: 'COMMON',
    Other: 'OTHER'
} as const;
export type StartWosJobTenantEnum = typeof StartWosJobTenantEnum[keyof typeof StartWosJobTenantEnum];
